import React, {useContext, useEffect} from "react"
import {getDocumentURL, getNodeCapability} from "../handler/ParentDataHandler";
import {getBaseUrl, parseCapabilitiesResponse} from "../util/Util";
import {CapabilityContext} from "../global/context/CapabilityContext";
import {AR_V2, CORE_AMZL, HEADERS} from "../util/Constants";
import {PICK_TAB_METRIC_KEY, logCounterMetric, RSWS_GET_CONFIG, RSWS_GET_STATION_CONFIG_SUCCESS} from "../util/MetricUtil";
import PickViewSelector from "./PickViewSelector";
import {PickViewSelectorContext} from "./context/PickViewSelectorContext"
import PickRouteView from "./PickRouteView";
import WorkstationView from "../workstationMetrics/WorkstationView";
import {PICK_VIEWS} from "./constants/Constants";
import PageHeader from "../util/PageHeader";
import {getStationCode} from "../network/NetworkUtil";
import Column from "@amzn/meridian/column";
import {useDeviceLayout} from "../common/context/DeviceLayoutContext";

const PickView = (props) => {
    const {configViewModel, configDispatch} = useContext(CapabilityContext)
    const {viewState} = useContext(PickViewSelectorContext)
    const stationCode = getStationCode();
    const {spacingInset_shorthand2} = useDeviceLayout()
    console.log(spacingInset_shorthand2)
    useEffect(() => {
        logCounterMetric(stationCode, PICK_TAB_METRIC_KEY, RSWS_GET_CONFIG);
        Promise.all([getDocumentURL(), getNodeCapability()]).then(result => {
            const model = {
                capability: parseCapabilitiesResponse(result[1]),
                baseUrl: getBaseUrl(result[0])
            }
            configDispatch({type: 'GET_CAPABILITIES', data: model});
            configDispatch({
                type: 'GET_STATION_CONFIG',
                data: {
                    dispatcher: configDispatch,
                    baseUrl: model.baseUrl,
                    metricKey: PICK_TAB_METRIC_KEY
                }
            });
        })
    }, []);

    useEffect(() => {
        if (configViewModel.capability !== '' && configViewModel.stationConfig.initialised) {
            logCounterMetric(stationCode, PICK_TAB_METRIC_KEY, RSWS_GET_STATION_CONFIG_SUCCESS);
        }

    }, [configViewModel.stationConfig.initialised]);

    return (
        <div>
            {configViewModel.capability !== '' && configViewModel.stationConfig.initialised ?
                (
                    <div>
                        <Column spacingInset={spacingInset_shorthand2} spacing={"none"}>
                            {configViewModel.capability === AR_V2 && <PageHeader {...HEADERS.PICK_AR_V2} />}
                        </Column>
                        <PickViewSelector />
                        {(configViewModel.capability === CORE_AMZL || viewState === PICK_VIEWS.ROUTE_VIEW) ? <PickRouteView history={props.history} /> : null}
                        {(configViewModel.capability === AR_V2 && viewState === PICK_VIEWS.WORKSTATION_VIEW) ? <WorkstationView /> : null}
                    </div>
                )
                : null}
        </div>
    )
}

export default PickView


// WEBPACK FOOTER //
// ./src/components/pickStatus/PickView.js